import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[injectContentHost]',
  standalone: false,
})
export class InjectContentHostDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
